/**
 * createdBy cc 2016-6-28
 * app模块左侧
 */
'use strict';
angular.module('editingCenterAppLeftModule', ['appLeftServiceModule']).controller('appLeftCtrl', [
    '$scope',
    '$state',
    '$q',
    'editingCenterService',
    'editingMediatype',
    '$filter',
    'trsHttpService',
    'globleParamsSet',
    '$timeout',
    'previewToolService',
    'appLeftService',
    'trsspliceString',
    'messagePublishService',
    '$sessionStorage',
    'localStorageService',
    'publicToolService',
    function(
        $scope,
        $state,
        $q,
        editingCenterService,
        editingMediatype,
        $filter,
        trsHttpService,
        globleParamsSet,
        $timeout,
        previewToolService,
        appLeftService,
        trsspliceString,
        messagePublishService,
        $sessionStorage,
        localStorageService,
        publicToolService
    ) {
        initStatus();

        /**
         * [initStatus description] 初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                AppSelectediframeId: 0,
                expandedNode: {
                    waitcompiled: [],
                    pending: [],
                    signed: [],
                    focus: [],
                    quicksign: [],
                },
                app: {
                    sites: '',
                    selectedSite: '',
                    tempSelectedSite: '',
                    utilBtns: {}, // 按钮工具类
                    mediaType: 1,
                    platformParam: {
                        waitcompiled: 7,
                        pending: 5,
                        signed: 6,
                        focus: 6,
                        quicksign: 7,
                    },
                    isDownPicShow: false, // 站点列表是否展开
                    isPanelOpen: {
                        0: false,
                    },
                    waitcompiled: {
                        channels: '',
                        selectedChnl: '',
                        isPanelOpen: {
                            0: false,
                        },
                    },
                    quicksign: {
                        channels: '',
                        selectedChnl: '',
                        isPanelOpen: {
                            0: false,
                        },
                        relatemanage: false,
                    },
                    pending: {
                        channels: '',
                        selectedChnl: '',
                        isPanelOpen: {
                            0: false,
                        },
                    },
                    signed: {
                        channels: '',
                        selectedChnl: '',
                        isPanelOpen: {
                            0: false,
                        },
                    },
                    focus: {
                        channels: '',
                        selectedChnl: '',
                        isPanelOpen: {
                            0: false,
                        },
                    },
                },
                // 签发失败总数量
                signFailNumber: 0,
            };

            // 兼容外链模块配置初始化
            /* $scope.status.app.isExternalsystem = $scope.status.app.selectedPlatform === 'externalsystem'; //判断是否进入到外链模块路由
                $scope.status.app.selectedPlatform = $scope.status.app.isExternalsystem ? 'waitcompiled' : $scope.status.app.selectedPlatform;*/
            // 兼容外链模块配置初始化结束
            $scope.data = {
                externalSystems: [],
            };
            $scope.treeOpts = editingCenterService.channelTreeOptions();
            initDropDownListBlur();
        }

        /**
         * [initDropDownListBlur description] 初始化下拉菜单失焦事件
         * @return {[type]} [description]
         */
        function initDropDownListBlur() {
            $('html')
                .unbind('click', myBlur)
                .bind('click', myBlur);

            /**
             * [myBlur description]
             * @param   {[type]}  $event  [$event description]
             * @return  {[type]}          [return description]
             */
            function myBlur($event) {
                var $target = $($event.target);
                if ($target.parents('.content_nav_select').length === 0) {
                    $timeout(function() {
                        $scope.status.app.isdownPicShow = false;
                    });
                }
            }

            $scope.$on('$destroy', function() {
                $('html').unbind('click', myBlur);
            });
        }

        $scope.initData = function(platForm) {
            initSites().then(function() {
                queryCommonChannels(platForm); // 查询已收藏的栏目  新增
                getAppSiteAccessAuthority();
                getIframeItems();
                changeAppPlatform(platForm);
                getRelationQX($scope.status.app.tempSelectedSite.SITEID);
            });
            messagePublishService.subscribe('refreshList', function() {
                queryQuickSignChannelsBySiteid($state.params.siteid).then(function(data) {
                    $scope.status.app.quicksign.channels = data;
                });
            },
                $scope
            );
        };

        /** 新增
         * [queryCommonChannels description] 查询已收藏的栏目
         * @return {[type]} [description]
         */
        function queryCommonChannels(platForm) {
            if (angular.isDefined($scope.status.commonChannels)&&!!$scope.status.commonChannels.flag) {
                return;
            }
            if (platForm === 'quicksign') {
                $scope.status.commonChannels = {};
                $scope.status.commonChannels.flag = false;
                return;
            }
            var params = {
                serviceid: 'mlf_appoper',
                methodname: 'queryCollectedChannels',
                SiteId: $scope.status.app.selectedSite.SITEID,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.status.commonChannels = angular.isArray(data) ? data : [];
            });
        }

        /** 新增
         * [cancelCommon description] 取消加入常用
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.cancelCommon = function(item) {
            delete $scope.status.commonChannels;
            var params = {
                serviceid: 'mlf_appoper',
                methodname: 'deleteCollectedChannels',
                CHNLCOLLECTRELID: item.CHNLCOLLECTRELID,
            };
            $('.tooltip-arrow').remove();
            $('.tooltip-inner').remove(); // tooltip组件的坑
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function() {
                queryCommonChannels();
            });
        };

        /**
         * [changeAppPlatform description]APP平台切换
         * @param   {[type]}  platform  [platform description]
         * @return  {[type]}            [return description]
         */
        function changeAppPlatform(platform) {
            if ($scope.status.app.selectedSite.SITETYPE == '-1') {
                return;
            } // 数采栏目 不允许返回数据
            $scope.status.AppSelectediframeId = 0;
            if ($scope.status.app.selectedPlatform === platform) {
                return;
            }
            $scope.status.app.selectedPlatform = platform;
            $scope.status.app[platform].isSelected = true;
            $scope.status.app.isExternalsystem = false;
            if (platform === 'quicksign') {
                initQuickChannel();
            } else {
                initChannel();
            }
        }

        /**
         * [initSites description]初始化站点
         * @return  {[type]}  [return description]
         */
        function initSites() {
            var defer = $q.defer();
            editingCenterService.querySitesByMediaType(editingMediatype.app).then(function(data) {
                $scope.status.app.sites = data.DATA;
                $scope.status.app.isDownImgShow = data.DATA.length > 1;
                var filteredSite = $filter('pick')(data.DATA, function(elm) {
                    if (elm) {
                        return elm.SITEID == $scope.appSiteId;
                    }
                });
                $scope.status.app.tempSelectedSite = $scope.status.app.selectedSite = filteredSite.length > 0 ? filteredSite[0] : data.DATA[0];
                if (data.DATA[0].SITETYPE === '-1') {
                    window.open('/wcm/stlogin/loginzjzxapp');
                    defer.reject();
                } else {
                    defer.resolve();
                }
            });
            return defer.promise;
        }

        /**
         * [getAppSiteAccessAuthority description] 初始化权限
         * @return {[type]} [description]
         */
        function getAppSiteAccessAuthority() {
            if (angular.isDefined($scope.status.appAccessAuthority)) {
                return;
            }
            var params = {
                serviceid: 'mlf_metadataright',
                methodname: 'queryAppSiteOperTypesBySiteId',
                SiteId: $scope.status.app.selectedSite.SITEID,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.status.appAccessAuthority = handlePermissionData(data);
            });
        }

        /**
         * [handlePermissionData description]处理权限数据
         * @param   {[type]}  data  [data description]
         * @return  {[type]}        [return description]
         */
        function handlePermissionData(data) {
            var obj = {};
            for (var i in data) {
                var array = data[i].split('.');
                obj[array[1]] = true;
            }
            return obj;
        }

        /**
         * [queryQuickSignChannelsBySiteid description]
         *
         * @param   {[type]}  siteid         [siteid description]
         *
         * @return  {[type]}                 [return description]
         */
        function queryQuickSignChannelsBySiteid(siteid) {
            var params = {
                serviceid: 'mlf_appquicksign',
                methodname: 'querySelectedChannel',
                siteid: siteid,
            };

            var defer = $q.defer();
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                if (data.length) {
                    angular.forEach(data, function(item) {
                        item.HASCHILDREN = 'false';
                    });
                    defer.resolve(data);
                } else {
                    defer.resolve(data);
                }
                $scope.status.app.selectedSite = $scope.status.app.tempSelectedSite;
            });
            return defer.promise;
        }

        /**
         * [initQuickChannel description]初始化栏目
         * @return  {[type]}  [return description]
         */
        function initQuickChannel() {
            var deffer = $q.defer();
            queryQuickSignChannelsBySiteid($scope.status.app.tempSelectedSite.SITEID)
                .then(function(data) {
                    $scope.status.app[$scope.status.app.selectedPlatform].channels = data;
                    // // $scope.status.app[$scope.status.app.selectedPlatform].hasChildren = data
                    // getRelationQX($scope.status.app.selectedSite.SITEID);
                    var routerChannelId = $scope.appChannelId;
                    if (data == undefined || !data.length) {
                        $scope.status.app[$scope.status.app.selectedPlatform].selectedChnl = [];
                    } else {
                        $scope.status.app[$scope.status.app.selectedPlatform].selectedChnl =
                            routerChannelId && $scope.appSiteId === $scope.status.app.selectedSite.SITEID
                                ? $filter('pick')(data, function(elm) {
                                    if (elm) {
                                        return elm.CHANNELID == routerChannelId;
                                    }
                                })[0]||data[0]
                                : data[0];
                    }
                    if (angular.isDefined($scope.status.app[$scope.status.app.selectedPlatform].selectedChnl)) {
                        routerChange();
                        deffer.resolve();
                    } else {
                        appLeftService
                            .positionSelectChannel(
                                $scope.status.app[$scope.status.app.selectedPlatform].channels,
                                routerChannelId,
                                $scope.status.app.platformParam[$scope.status.app.selectedPlatform],
                                $scope.status.expandedNode[$scope.status.app.selectedPlatform],
                            )
                            .then(function(selectedChannel) {
                                $scope.status.app[$scope.status.app.selectedPlatform].selectedChnl = selectedChannel;
                                routerChange();
                                deffer.resolve();
                            });
                    }
                });
            return deffer.promise;
        }

        /**
         * [initChannel description]初始化栏目
         * @return  {[type]}  [return description]
         */
        function initChannel() {
            var deffer = $q.defer();
            editingCenterService.queryClassifyBySite($scope.status.app.selectedSite.SITEID, $scope.status.app.platformParam[$scope.status.app.selectedPlatform], true)
                .then(function(data) {
                    initSignedFailNum();
                    if (angular.isDefined(data.CHILDREN)) {
                        judgeConfigType(data.CHILDREN);
                    }
                    // 因为焦点图有所有栏目无意义 故不要
                    if ($scope.status.app.selectedPlatform === 'focus') {
                        $scope.status.app[$scope.status.app.selectedPlatform].channels = data.CHILDREN.length > 1 ? data.CHILDREN.slice(1) : data.CHILDREN;
                    } else {
                        $scope.status.app[$scope.status.app.selectedPlatform].channels = data.CHILDREN;
                    }
                    // $scope.status.app[$scope.status.app.selectedPlatform].hasChildren = data
                    var routerChannelId = $scope.appChannelId;
                    if (data.CHILDREN == undefined) {
                        $scope.status.app[$scope.status.app.selectedPlatform].selectedChnl = [];
                    } else {
                        $scope.status.app[$scope.status.app.selectedPlatform].selectedChnl =
                            routerChannelId && $scope.appSiteId === $scope.status.app.selectedSite.SITEID
                                ? $filter('pick')(data.CHILDREN, function(elm) {
                                    if (elm) {
                                        return elm.CHANNELID == routerChannelId;
                                    }
                                })[0]||data[0]
                                : data.CHILDREN[0];
                        if ($scope.status.app.selectedPlatform === 'focus') {
                            $scope.status.app[$scope.status.app.selectedPlatform].selectedChnl = $scope.status.app[$scope.status.app.selectedPlatform].channels[0];
                        }
                    }
                    if (angular.isDefined($scope.status.app[$scope.status.app.selectedPlatform].selectedChnl)) {
                        routerChange();
                        deffer.resolve();
                    } else {
                        appLeftService
                            .positionSelectChannel(
                                $scope.status.app[$scope.status.app.selectedPlatform].channels,
                                routerChannelId,
                                $scope.status.app.platformParam[$scope.status.app.selectedPlatform],
                                $scope.status.expandedNode[$scope.status.app.selectedPlatform],
                            )
                            .then(function(selectedChannel) {
                                $scope.status.app[$scope.status.app.selectedPlatform].selectedChnl = selectedChannel;
                                routerChange();
                                deffer.resolve();
                            });
                    }

                    /* $scope.status.app[$scope.status.app.selectedPlatform].selectedChnl = angular.isDefined(data.CHILDREN) ? data.CHILDREN[0] : {};
                    routerChange();*/
                });
            return deffer.promise;
        }

        /**
         * [judgeConfigType 判断是否存在配置项]
         * @param  {[type]} node [description]
         * @return {[type]}      [description]
         */
        function initSignedFailNum() {
            var defer = $q.defer();
            var params = {
                serviceid: 'message',
                method: 'queryBySiteId',
                opertype: '124',
                siteId: $scope.status.app.selectedSite.SITEID,
                socketid: $sessionStorage.get('curUserInfo').ID
            };
            trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, "GET").then(function(data) {
                $scope.status.signFailNumber = data.data.sum || 0;
                $scope.status.channelSignFail = data.data.channelList;
                angular.forEach($scope.status.app[$scope.status.app.selectedPlatform].channels, function (_data) {
                    if( _data.CHANNELID) {
                        _data.signedChannelFail = $scope.status.channelSignFail[_data.CHANNELID] || 0;
                    }
                });
                messagePublishService.publish('getAppSignedFailNum', $scope.status.signFailNumber);
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [judgeConfigType 判断是否存在配置项]
         * @param  {[type]} node [description]
         * @return {[type]}      [description]
         */
        function judgeConfigType(node) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_publishinsametime',
                methodname: 'queryRelsTypeByChannelId',
                ChannelIds: trsspliceString.spliceString(node, 'CHANNELID', ','),
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                for (var i = 0; i < node.length; i++) {
                    if (data[node[i].CHANNELID] != 0) {
                        node[i].relType = data[node[i].CHANNELID];
                    }
                }
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [routerChange description]路由切换
         * @return  {[type]}  [return description]
         */
        function routerChange() {
            var router = '';
            if ($scope.status.app.isExternalsystem) {
                router = 'front.editctr.app.externalsystem';
                $state.go(router, { siteid: $scope.status.app.selectedSite.SITEID }, { reload: router });
                return;
            }
            router = 'front.editctr.app.' + $scope.status.app.selectedPlatform;
            $state.go(
                router,
                {
                    channelid: $scope.status.app[$scope.status.app.selectedPlatform].selectedChnl.CHANNELID,
                    siteid: $scope.status.app.selectedSite.SITEID,
                    hasChildren: $scope.status.app[$scope.status.app.selectedPlatform].selectedChnl.CHILDREN ? 'true' : 'false',
                },
                { reload: router },
            );
        }

        /**
         * [setAppQuickSignSiteSelected description]修改一键快签的站点
         *
         * @param   {[type]}  site  [site description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.setAppQuickSignSiteSelected = function(site) {
            if ($scope.status.app.selectedSite == site) {
                return;
            }
            $scope.status.app.tempSelectedSite = site;
            getRelationQX(site.SITEID);
            initQuickChannel().then(function() {
                $scope.status.expandedNode = {
                    waitcompiled: [],
                    pending: [],
                    signed: [],
                    focus: [],
                    quicksign: [],
                };
                $scope.status.app.isExternalsystem = false;
                delete $scope.status.commonChannels;
                // queryCommonChannels();
                delete $scope.data.externalSystems;
                // getIframeItems();
                delete $scope.status.appAccessAuthority;
                // getAppSiteAccessAuthority();
            });
        };

        // 站点切换
        $scope.setAppSiteSelected = function(site) {

            /* if (site.SITETYPE === "-1") {
                    window.open("/wcm/stlogin/loginzjzxapp");
                    return;
                }*/
            if ($scope.status.app.selectedSite == site) {
                return;
            }
            $scope.status.app.selectedSite = site;
            getRelationQX(site.SITEID);
            initChannel().then(function() {
                $scope.status.expandedNode = {
                    waitcompiled: [],
                    pending: [],
                    signed: [],
                    quicksign: [],
                };
                // $scope.status.app.isExternalsystem = false;
                delete $scope.status.commonChannels;
                queryCommonChannels();
                delete $scope.data.externalSystems;
                getIframeItems();
                delete $scope.status.appAccessAuthority;
                getAppSiteAccessAuthority();
            });
        };
        $scope.setAppSelectedChnl = function(item, platform) {
            $scope.status.AppSelectediframeId = 0;
            $scope.status.isMoreIconsShow = '';
            $scope.status.app[platform].selectedChnl = item;
            if(platform === 'signed' && item.signedChannelFail) {
                readmessages(item);
            }
            var param;
            if (angular.isObject(item)) {
                $state.go(
                    'front.editctr.app.' + platform,
                    {
                        channelid: item.CHANNELID,
                        hasChildren: item.CHILDREN ? 'true' : 'false',
                    },
                    { reload: 'front.editctr.app.' + platform },
                );
            } else {
                if (item === 'myshare') {
                    param = { mediatype: 1, hasChildren: item.CHILDREN ? 'true' : 'false' };
                }
                $state.go('front.editctr.app.' + platform + '.' + item, param, { reload: 'front.editctr.app.' + platform + '.' + item });
            }
        };

        /** 新增
         * [channelPreview description]栏目预览
         * @param  {[obj]} chl [description]当前栏目信息
         * @return {[type]}     [description]null
         */
        $scope.websiteChannelPreview = function(chl) {
            // websiteService.websiteChannelPreview(chl);
            previewToolService.channelPreview(chl);
            window.event.stopPropagation();
        };

        /**
         * [readmessages description]按照站点读取数据 并且发一个请求
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        function readmessages(item) {
            publicToolService.readmessagesByChannelId(
                {
                    CHANNELID: item.CHANNELID,
                    OPERTYPE: '124',
                    SITEID: item.SITEID,
                }
            ).then(() => {
                publicToolService.queryunreadmsgbySiteId('124', item.SITEID).then((data) => {
                    messagePublishService.publish('getAppSignedFailNum', data.data.sum);
                });
                item.signedChannelFail = undefined;
            });
        }
        /** 新增
         * [commonChannelsIsSelected description]
         * @param {[object]} [commonChannel] [description] 常用栏目是否选中
         * @param {string} [platform] [description] 平台
         * @return {[type]} [description]
         */
        $scope.commonChannelsIsSelected = function(commonChannel, platform) {
            return (
                commonChannel === $scope.status.app.waitcompiled.selectedChnl ||
                commonChannel === $scope.status.app.pending.selectedChnl ||
                commonChannel === $scope.status.app.signed.selectedChnl ||
                commonChannel === $scope.status.app.focus.selectedChnl
            );
        };

        /**
         * [getIframeItems description]获取外链列表
         * @param   {[type]}  site  [site description]
         * @return  {[type]}        [return description]
         */
        function getIframeItems(site) {
            var params = {
                serviceid: 'mlf_appconfig',
                methodname: 'queryExtSysBySite',
                CurrPage: 1,
                pagesize: 200,
                SITEID: $scope.status.app.selectedSite.SITEID,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.externalSystems = data.DATA;
            });
        }

        $scope.setAppSelectediframe = function(externalSys, item, platform) {
            // $scope.status.app[platform].selectedChnl = item;
            // 如果是外链则：直接新窗口打开外链
            if ($scope.status.app[platform]) {
                delete $scope.status.app[platform].selectedChnl;
            }
            if (externalSys.PATTERN === '2') {
                window.open(externalSys.EXTSYSADD);
            } else {
                $scope.status.AppSelectediframeId = externalSys.EXTERNALSYSTEMID;
                var router = 'front.editctr.app.' + platform + '.externalsystem';
                $state.go(router, {
                    siteid: $scope.status.app.selectedSite.SITEID,
                    externalsystemurl: externalSys.EXTSYSADD,
                }, { reload: router });
            }
        };

        /** 新增
         * [addToCommon description] 添加为常用栏目
         * @param {[object]} [node] [description] 栏目数据
         * @return {[type]} [description]
         */
        $scope.addToCommon = function(node) {
            delete $scope.status.commonChannels;
            var params = {
                serviceid: 'mlf_appoper',
                methodname: 'collectChannels',
                SiteId: $scope.status.app.selectedSite.SITEID,
                ChannelId: node.CHANNELID,
                ChnlDesc: node.CHNLDESC,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                queryCommonChannels();
            });
        };

        /**
         * [getSelectedNode description] 判断栏目树中的栏目是否被选中
         * @return {[type]} [description]
         */
        $scope.getSelectedNode = function() {
            if (angular.isUndefined($scope.status.app.selectedPlatform)) {
                return;
            }
            if (angular.isObject($scope.status.app[$scope.status.app.selectedPlatform].selectedChnl)) {
                return $scope.status.app[$scope.status.app.selectedPlatform].selectedChnl;
            } else {
                return undefined;
            }
        };

        /**
         * [queryNodeChildren description]查询子节点
         * @param  {[obj]} node     [description]节点信息
         * @param  {[num]} platform [description]平台
         * @return {[type]}          [description]
         */
        $scope.queryNodeChildren = function(node, platform) {
            if (node.CHANNELID === '0') {
                return;
            }
            editingCenterService.queryChildChannel(node, platform).then(function(children) {
                if (angular.isDefined(children)) {
                    judgeConfigType(children);
                }
                node.CHILDREN = children;
                angular.forEach(node.CHILDREN, function (_data) {
                    if( _data.CHANNELID) {
                        _data.signedChannelFail = $scope.status.channelSignFail[_data.CHANNELID] || 0;
                    }
                });
            });
        };

        /**
         * [siteCut description]  根据不同分辨率截取不同长度的名称
         * @param {[type]} site [description]
         */
        $scope.siteCut = function(site) {
            if (window.screen.width <= '1366') {
                site = $filter('trsLimitTo')(site, '8');
            } else if (window.screen.width <= '1680' && window.screen.width > '1366') {
                site = $filter('trsLimitTo')(site, '10');
            } else if (window.screen.width > '1680') {
                site = $filter('trsLimitTo')(site, '12');
            }
            return site;
        };

        /**
         * [goToZjNews description] 新疆新闻后台
         * @return {[type]} [description]
         */
        $scope.goToZjNews = function() {
            window.open('/wcm/stlogin/loginzjzxapp');
        };

        $scope.turnToGjgl = function() {
            $state.go('front.editctr.app.quicksign.gjglmk', { reload: 'front.editctr.app.quicksign.gjglmk' });
        };

        //请求快签下的关联权限
        function getRelationQX(siteid) {
            var params = {
                serviceid: 'mlf_metadataright',
                methodname: 'queryOperKeyByBaseChannel',
                SiteId: siteid,
                Classify: 'appsite.quicksign',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                if (data && data.length > 0) {
                    $scope.status.app.quicksign.relatemanage = data.some((item) => {
                        return item.OPERNAME === 'appsite.quicksign.relatemanage';
                    });
                    // 发布一条消息
                    messagePublishService.publish('refreshOneKeySigning', true);
                } else {
                    messagePublishService.publish('refreshOneKeySigning', false);
                    $scope.status.app.quicksign.relatemanage = false;
                }
            });
        }
    },
]);
